import React, { Component } from 'react';
import { matchRoutes } from 'react-router-config';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as LoginActions from 'auth/store/actions/index';
import _ from 'lodash';
import * as HelperFunctions from '../../../main/components/helpers';
import { chat_url } from 'config';
import { Tooltip, Typography } from '@material-ui/core';

let redirect = false;

class FuseAuthorization extends Component {

    constructor(props) {
        super(props);
        this.loginAuth();
    }

    state = { chatOpen: false, chatTooltipOpen: false }

    componentDidUpdate(prevProps) {
        const matched = matchRoutes(this.props.routes, this.props.location.pathname)[0];
        this.checkPermissions(this.props.location.pathname, matched.route.permission);
        this.checkAuth(matched);
    }

    componentWillUpdate = async () => {
        if (this.props.location.pathname !== '/landing') {
            await this.props.checkPortalTokenValid(localStorage.getItem("portalToken"))
        }
    }

    loginAuth() {
        const local_token = localStorage.getItem('token');
        const token_date = localStorage.getItem('token_date');

        if (local_token !== null) {
            this.props.submitLoginJWT(local_token, token_date);
        } else {
            this.props.setTokenCheck();
        }
    }

    checkPermissions(route_path, route_permission) {
        const split_path = route_path.split("/");
        const view_type = split_path[2] || '';

        let { component_name, permission_type } = route_permission || {};

        // Grab associated permission_type from route if generic
        if (permission_type === 'view_type') {
            permission_type = view_type;
        }

        // If no permission set for route, allow all
        if (typeof route_permission === 'undefined') {
            return;
        }

        if (HelperFunctions.checkPermission(this.props.user.data.permissionList, component_name, permission_type)) {
            // console.log('Permission Found.', component_name, permission_type);
        } else {
            // console.log('No Permission Found.', component_name, permission_type);

            redirect = true;
            this.props.history.push({
                pathname: '/'
            });
        }
    }

    checkAuth(matched) {
        if (matched && matched.route.auth && matched.route.auth.length > 0) {
            if (!matched.route.auth.includes(this.props.user.role)) {
                redirect = true;
                let role = this.props.user.role;
                if (role === 'guest') {
                    this.props.history.push({
                        pathname: '/login',
                        state: { redirectUrl: this.props.location.pathname }
                    });
                }
                else {
                    this.props.history.push({
                        pathname: '/'
                    });
                }
            }
        }
    }


    shouldComponentUpdate(nextProps) {
        if (redirect) {
            redirect = false;
            return false;
        }
        else {
            return true;
        }
    }

    receiveMessage = (event) => {
        if (event.data.fn === 'restoreWindow') {
            this.setState({ chatOpen: true, chatTooltipOpen: false })
        }
        else if (event.data.fn === 'minimizeWindow') {
            this.setState({ chatOpen: false })
        }
    }

    handleChatTooltipOpen = () => {
        if (this.state.chatOpen)  {
          return 
        }
        this.setState({ chatTooltipOpen: true })
      }
    
    handleChatTooltipClosed = () => {
        this.setState({ chatTooltipOpen: false })
      }

    render() {
        window.addEventListener("message", this.receiveMessage, true);
        const { children, user } = this.props;
        if (!user.tokenCheck) {
            return (
                <React.Fragment>

                </React.Fragment>
            );
        }

        return (
            <React.Fragment>
                {children}
                <Tooltip
                    title={<div style={{ fontSize: '16px', padding: '4px' }}>Live Support</div>}
                    // title={'Live Support'}
                    placement={'left'}
                    open={this.state.chatTooltipOpen}
                    onOpen={this.handleChatTooltipOpen}
                    onClose={this.handleChatTooltipClosed}
                >   
                    <iframe src={chat_url + '/' + user.data.sessionKey} style={{ position: 'absolute', bottom: 0, right: 0, height: this.state.chatOpen ? '500px' : '100px', width: this.state.chatOpen ? '500px' : '100px', zIndex: 10 }}></iframe>
                </Tooltip>    
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        submitLoginJWT: LoginActions.submitLoginJWT,
        setTokenCheck: LoginActions.setTokenCheck,
        checkPortalTokenValid: LoginActions.checkPortalTokenValid
    }, dispatch);
}

function mapStateToProps({ fuse, auth }) {
    return {
        user: auth.user
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FuseAuthorization));



// WEBPACK FOOTER //
// src/@fuse/components/FuseAuthorization/FuseAuthorization.js